import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { IDonutChartProps, IHighchartOptions } from './types'
import './style.css'

const options: IHighchartOptions = {
  credits: {
    enabled: false,
  },
  chart: {
    type: 'pie',
    backgroundColor: 'transparent',
  },
  legend: {
    itemMarginBottom: 20,
    itemDistance: 20,
    enabled: true,
    layout: 'horizontal',
    align: 'right',
    verticalAlign: 'middle',
    useHTML: true,
    labelFormatter: function () {
      return `<p class="caption-12-medium color-headline-secondary">${
        this.name
      }</p> <p class="caption-14-medium color-body-default">${this.yFormatted || this.y} </p>`
    },
  },
  colors: [],
  title: null,
  tooltip: {
    borderRadius: 4,
    enabled: true,
    useHTML: true,
    padding: -10,
    margin: 0,
    width: 'fit-content',
    formatter: function () {
      return `<div class="background-surface-light tooltip">
      <p class="caption-14-medium color-body-default">${this.point.name} </p> 
      <p class="caption-12-regular color-headline-secondary">${
        this.point.yFormatted || this.point.y
      } </p> 
      </div>`
    },
  },
  series: [
    {
      data: [],
      innerSize: '70%',
      dataLabels: {
        enabled: false,
      },
    },
  ],

  plotOptions: {
    pie: {
      showInLegend: true,
      borderWidth: null,
      borderRadius: null,
      cursor: 'pointer',
      dataLabels: {
        enabled: false,
      },
      animation: false,
    },
  },
}
const DonutChart = ({
  alignLegend = 'center',
  colors = [],
  hasAnimation = false,
  data = [],
  legendItemsColumnGap = 20,
  legendItemsRowGap = 20,
  legendPosition = 'bottom',
  showLegend = true,
  legendWith,
  spacing,
}: IDonutChartProps) => {
  const getChartOptions = () => {
    const newOptions = { ...options }
    newOptions.colors = colors
    newOptions.legend.align = alignLegend
    newOptions.legend.enabled = showLegend
    newOptions.legend.verticalAlign = legendPosition
    newOptions.series[0].data = data
    newOptions.legend.itemMarginBottom = legendItemsRowGap
    newOptions.legend.itemDistance = legendItemsColumnGap
    newOptions.legend.width = legendWith
    newOptions.chart.spacing = spacing
    newOptions.plotOptions.pie.animation = hasAnimation
    return newOptions
  }

  return <HighchartsReact highcharts={Highcharts} options={getChartOptions()} />
}

export default DonutChart
